import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1421.14123,3.0066885 L1512.916,67.2688495 L215.481342,1919.55138 L216.076,1919.96785 L215.698175,1920.50798 L123.327514,1855.82935 L246.487,1679.99985 L0,1680 L0,240 L1255.139,239.999849 L1421.14123,3.0066885 Z M1500.536,281.493849 L1500.53647,791.830588 L1920,346.051765 L1920,1574.06118 L1500.53647,1128.16941 L1500.53647,1680 L520.95,1679.99985 L1500.536,281.493849 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconVideoCameraOffSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconVideoCameraOffSolid, _Component);

  var _super = _createSuper(IconVideoCameraOffSolid);

  function IconVideoCameraOffSolid() {
    _classCallCheck(this, IconVideoCameraOffSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconVideoCameraOffSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconVideoCameraOff",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconVideoCameraOffSolid.displayName = "IconVideoCameraOffSolid";
  return IconVideoCameraOffSolid;
}(Component);

IconVideoCameraOffSolid.glyphName = 'video-camera-off';
IconVideoCameraOffSolid.variant = 'Solid';
IconVideoCameraOffSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconVideoCameraOffSolid;
export { IconVideoCameraOffSolid };